import ApiService from "./ApiService";

/**
 * Service to handle requests about companies
 */
const CompanyService = {
  async getCompanies(params?: { name?: string } & Pageable): Promise<Page<CompanyDTO>> {
    return ApiService.get<Page<CompanyDTO>>("/companies", params as Record<string, unknown>);
  },
  async getCompanyById(id: string): Promise<CompanyWithUsersDTO> {
    return ApiService.get<CompanyWithUsersDTO>(`/companies/${id}`);
  },
  async createCompany(dto: { name: string }): Promise<CompanyDTO> {
    return ApiService.post<CompanyDTO>("/companies", dto);
  },
  async deleteCompany(id: string): Promise<void> {
    return ApiService.delete(`/companies/${id}`);
  },
};

export default CompanyService;
